// extracted by mini-css-extract-plugin
module.exports = {"contentContainer":"p-Hgns7L","title":"YgdQnh-Z","text":"_1CiU2P1y","image":"_2NxK-gc9","ctaTextAndImage":"_2L2rznjt","isLeft":"C9PxG4t4"};